import React from "react";

function Recipes() {
  return <div>Here the recipes will come</div>;
}

export default Recipes;
